<template>
  <div class="chart-container">
    <div class="chart-header" style="display: flex;justify-content: flex-end;">
       <border-box v-if="title !== ''" :message="title"></border-box>
      <div class="unit">
        <select @change="selectYearData" aria-placeholder="年份" v-model="chosedOptinOne">
          <option v-for="year in yearList" :value="year.value" :key="year.value">{{year.label}}</option>
        </select>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between;height:100%;width: 100%">
      <div style="width: 33%;">
        <div class="pie-class">报修总量及占比</div>
        <div :style="chartStyle" id="left_middle_1_chart"></div>
      </div>
      <div style="width: 33%;">
        <div class="pie-class">系统报修量占比</div>
        <div :style="chartStyle" id="left_middle_3_chart"></div>
      </div>
      <div style="width: 33%;">
        <div class="pie-class">安检量及占比</div>
        <div :style="chartStyle" id="left_middle_2_chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { selectYear, selectRepair, selectSecurityCheck, selectOrderProportion } from '@/api/dataview/repairAmount'
import BorderBox from '../border/BorderBox'
var echartsMap
export default {
  name: 'RepairAmount',
  components: { BorderBox },
  props: ['title', 'unit'],
  data () {
    return {
      chartStyle: { width: '100%', height: '80%',border:'0px solid red' },
      yearList: [],
      chosedOptinOne: ''
    }
  },
  mounted () {
    var that = this
    var param = {}
    param.type = 'dashboard-year'
    // 当前用户累计总数
    selectYear(param).then(res => {
      if (res.code === 200) {
        that.yearList = res.data
        for (var i = 0; i < that.yearList.length; i++) {
            if(that.yearList[i].isDefault){
                that.chosedOptinOne = that.yearList[i].value
                //console.log(that.chosedOptinOne)
            }
        }
        //that.chosedOptinOne = that.yearList[0].value
        that.loadGauge1(that.chosedOptinOne)
        that.loadGauge2(that.chosedOptinOne)
        that.loadGauge3(that.chosedOptinOne)
      }
    })
  },
  methods: {
    selectYearData () {
      var that = this
      // console.log(that.chosedOptinOne)
      that.loadGauge1(that.chosedOptinOne)
      that.loadGauge2(that.chosedOptinOne)
      that.loadGauge3(that.chosedOptinOne)
    },
    loadGauge3 (year) {
      var that = this
      var echartsMap3 = that.$echarts.init(document.getElementById('left_middle_3_chart'))
      var param = {}
      param.year = year
      selectOrderProportion(param).then(res => {
        if (res.code === 200) {
          var data = []
          for (var j = 0; j < res.data.length; j++) {
            var json = {}
            json.name = res.data[j].name
            json.value = res.data[j].quantity
            data.push(json)
          }
          var option3 = {
            grid: {
              top: '1px',
              left: '1px',
              right: '1px',
              containLabel: true
            },
            tooltip: {
              //trigger: 'axis'
            },
            // legend: {
            //   type: 'plain',
            //   show: false,
            //   orient: 'vertical',
            //   right: 20,
            //   top: '25%',
            //   bottom: '20%',
            //   icon: 'circle',
            //   itemHeight: 10,
            //   align: 'left',
            //   padding: [0, 0, 10, 0],
            //   width: '50%',
            //   textStyle: {
            //     color: '#88e3ff',
            //     fontSize: 20,
            //     overflow: 'truncate',
            //     width: 220,
            //     rich: {
            //       a: {
            //         align: 'left',
            //         fontSize: 13
            //       },
            //       b: {
            //         align: 'right',
            //         fontSize: 13
            //       }
            //     }
            //   },
            //   formatter (name) {
            //     const count = pieCount
            //     const val = pieData.filter(item => {
            //       return item.name === name
            //     })
            //     return '{a|' + name + ' ' + '}' + '{b|' + ((val[0].value / count) * 100).toFixed(2) + '% / ' + val[0].value + '户}'
            //   }
            // },
            series: [{
              name: '',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              // label: {
              //   show: false
              // },
              width: '100%',
              data: data,
              label: {// 饼图图像文本标签
                show:false,
                position: 'center',
                formatter: function () {
                  let count = 0
                  let str = '{a|总用户数}' + '\n' + '{b|' + count + '}'
                  return str
                },
                rich: {// 富文本样式
                  a: {
                    color: '#88e3ff',
                    fontSize: '13px'
                  },
                  b: {
                    color: '#66FFCC',
                    fontWeight: 'bold',
                    fontSize: '16px'
                  }
                }

              }
            }]
          }
          console.log(JSON.stringify(option3))
          echartsMap3.setOption(option3)

          window.addEventListener("resize", function() {
            echartsMap3.resize();
          });
        }
      })
    },
    loadGauge2 (year) {
      var that = this
      var echartsMap2 = that.$echarts.init(document.getElementById('left_middle_2_chart'))

      var param = {}
      param.year = year
      selectSecurityCheck(param).then(res => {
        if (res.code === 200) {
          var validUser = res.data.validUser
          var reportCount = res.data.reportCount
          var percent = ((reportCount / validUser) * 100).toFixed(1)

          var option2 = {
            grid: {
              top: '1%',
              left: '1%',
              right: '1%',
              bottom: '1%',
              containLabel: true
            },
            series: [
              {
                name: 'Pressure',
                type: 'gauge',
                pointer: {
                  icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                  length: '15%',
                  width: 7,
                  offsetCenter: [0, '-60%'],
                  itemStyle: {
                    color: 'auto'
                  }
                },
                axisTick: {
                  distance: -9,
                  length: 5,
                  lineStyle: {
                    color: '#333',
                    width: 1
                  }
                },
                axisLine: {
                  lineStyle: {
                    width: 10,
                    color: [[1, '#88e3ff']]
                  }
                },
                axisLabel: {
                  show: false,
                  distance: -30,
                  color: '#88e3ff',
                  fontSize: 10
                },
                splitLine: {
                  show: false,
                  length: 5,
                  lineStyle: {
                    width: 2,
                    color: '#999'
                  }
                },
                anchor: {
                  show: false,
                  // showAbove: true,
                  // size: 25,
                  itemStyle: {
                    // borderWidth: 10
                  }
                },
                title: {
                  show: true,
                  fontSize: 12,
                  offsetCenter: [0, '10%'],
                  color: '#88e3ff'
                },
                detail: {
                  valueAnimation: true,
                  fontSize: 12,
                  offsetCenter: [0, '50%'],
                  color: '#66FFCC',
                  formatter: '{value}%'
                },
                // detail: { formatter: '{value}' },
                data: [
                  {
                    value: percent,
                    name: reportCount
                  }
                ]
              }
            ]
          }
          echartsMap2.setOption(option2)

          window.addEventListener("resize", function() {
            echartsMap2.resize();
          });
        }
      })
    },
    loadGauge1 (year) {
      var that = this
      echartsMap = that.$echarts.init(document.getElementById('left_middle_1_chart'))
      var param = {}
      param.year = year
      selectRepair(param).then(res => {
        if (res.code === 200) {
          var validUser = res.data.validUser
          var orderOfYear = res.data.orderOfYear
          var percent = ((orderOfYear / validUser) * 100).toFixed(1)

          var option = {
            grid: {
              top: '1%',
              left: '1%',
              right: '1%',
              bottom: '1%',
              containLabel: true
            },
            series: [
              {
                name: 'Pressure',
                type: 'gauge',
                pointer: {
                  icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                  length: '35%',
                  width: 3,
                  offsetCenter: [0, '-60%'],
                  itemStyle: {
                    color: 'auto'
                  }
                },
                axisTick: {
                  distance: -9,
                  length: 5,
                  lineStyle: {
                    color: '#333',
                    width: 1
                  }
                },
                axisLine: {
                  lineStyle: {
                    width: 10,
                    color: [[1, '#FFAB91']]
                  }
                },
                axisLabel: {
                  show: false,
                  distance: -30,
                  color: '#88e3ff',
                  fontSize: 10
                },
                splitLine: {
                  show: false,
                  length: 5,
                  lineStyle: {
                    width: 2,
                    color: '#999'
                  }
                },
                anchor: {
                  show: false,
                  // showAbove: true,
                  // size: 25,
                  itemStyle: {
                    // borderWidth: 10
                  }
                },
                title: {
                  show: true,
                  fontSize: 12,
                  offsetCenter: [0, '10%'],
                  color: '#88e3ff'
                },
                detail: {
                  valueAnimation: true,
                  fontSize: 11,
                  offsetCenter: [0, '50%'],
                  color: '#66FFCC',
                  formatter: '{value}%'
                },
                // detail: {                formatter: '{value}'              },
                data: [
                  {
                    value: percent,
                    name: orderOfYear
                  }
                ]
              }
            ]
          }
          echartsMap.setOption(option)

          window.addEventListener("resize", function() {
            echartsMap.resize();
          });
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.chart-container
  display flex
  flex-direction column
  // border 1px solid rgba(14, 101, 187, 0.66);
  height calc(100%) .chart-header
    display flex
    // border-box
    // flex-grow auto
    justify-content space-between
    .unit
      width 60px
      margin-right 8px
      line-height 30px
      font-size 15px
      font-family Microsoft YaHei
      font-weight 400
      color white
.pie-class
  color #02b5e8
  border-left 5px solid #02b5e8
  padding-left 5px
  font-size 12px
</style>
